import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { updateCurrentEntityAction } from 'actions/applicationActions'
import CameraList from './CameraList'
import FloorPlanScaler from './FloorPlanScaler'
import LabelDetails from './LabelDetails'
import FloorPlanDetails from './FloorPlanDetails'
import EditShape from './EditShape'
import WireDetails from './WireDetails'
import NetworkClosetDetails from './NetworkClosetDetails'
import WiredDeviceDetails from './WiredDeviceDetails'
import DoorEntityDetails from './DoorEntityDetails'
import ModelSelector from './ModelSelector'
import LensSelector from './ModelSelector/LensSelector'
import CameraConfig from './CameraConfig'
import SimulatedView from './SimulatedView'
import { MobilePpfPreview } from 'components/PpfPreview'
import WiringPanel from './WiringPanel'
import DefaultButtons from './Buttons'
import CameraButtons from './Buttons/cameraButtons'
import { FloorPlanButtons, EditEntityButton } from './Buttons/otherButtons'
import { wiredDeviceTypeSelector } from 'selectors/components'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import omit from 'ramda/src/omit'

const mapStateToProps = state => {
  const { currentEntity, cameraModels, ui: { scaling } } = state
  const currentCamera = getCurrentCamera(state.cameras)

  return {
    cameraSelected: currentCamera && currentEntity.type === 'camera' && currentEntity.id === currentCamera.id,
    wiredDeviceType: wiredDeviceTypeSelector(state),
    currentCamera,
    cameraModels,
    currentEntity,
    scaling
  }
}

class BottomBar extends React.Component {
  constructor(props) {
    super(props)
    this.highlightTimer = null
    this.state = { highlightAddNetworkCloset: false }
  }

  componentWillUnmount = _ => clearTimeout(this.highlightTimer)

  highlightNetworkClosetListener = event => {
    event.stopPropagation()

    clearTimeout(this.highlightTimer)
    this.setState({ highlightAddNetworkCloset: true })
    this.props.updateCurrentEntityAction({ type: 'map' })
    this.props.close()

    this.highlightTimer = setTimeout(_ => this.setState({ highlightAddNetworkCloset: false }), 2000)
  }

  render() {
    const { panel, setPanel, openCameraPanel, close, scaling, cameraModels, currentCamera, currentEntity, openFloorplan,
      openLabel, cameraSelected, wiredDeviceType, classes } = this.props

    if (panel === 'cameraList') return <CameraList close={close} />

    // Panels
    if (scaling) return <FloorPlanScaler />

    switch (panel) {
      case 'editLabel': return <LabelDetails />
      case 'editFloorplan': return <FloorPlanDetails />
      case 'editShape': return <EditShape />
      case 'editWire': return <WireDetails />
      case 'editNetworkCloset': return <NetworkClosetDetails />
      case 'editWiredDevice': return <WiredDeviceDetails highlightNetworkClosetListener={this.highlightNetworkClosetListener} />
      case 'editDoorController': return <DoorEntityDetails isController />
      case 'editDoor': return <DoorEntityDetails />
      // Camera panels
      case 'selectModel':
        if (!cameraModels) {
          return (
            <div className={classes.loading}>
              <FontAwesomeIcon icon='spinner' className={`${classes.loadingButton} fa-spin`} />
              Loading Models...
            </div>
          )
        }
        return currentCamera.imagerId ? <LensSelector close={close} /> : <ModelSelector close={close} />
      case 'editConfig': return <CameraConfig close={close} openSelector={openCameraPanel('selectModel')} />
      case 'simulatedView': return <SimulatedView close={close} />
      case 'simulatedPerson': return <MobilePpfPreview close={close} key='ppfpreview' />
      case 'wiringPanel': return <WiringPanel highlightNetworkClosetListener={this.highlightNetworkClosetListener} />
    }

    // Buttons
    switch (currentEntity.type) {
      case 'floorPlan': return <FloorPlanButtons openFloorplan={openFloorplan} />
      case 'label': return <EditEntityButton open={openLabel} />
      case 'wire': return <EditEntityButton open={setPanel('editWire')} />
      case 'networkCloset': return <EditEntityButton open={setPanel('editNetworkCloset')} buttonLabel='Network Closet' />
      case 'wiredDevice': return <EditEntityButton open={setPanel('editWiredDevice')} buttonLabel={wiredDeviceType} />
      case 'doorController': return <EditEntityButton open={setPanel('editDoorController')} buttonLabel='Door Controller' />
      case 'door': return <EditEntityButton open={setPanel('editDoor')} />
      case 'circle':
      case 'polygon':
      case 'polyline':
      case 'rectangle':
      case 'wall':
        return <EditEntityButton open={setPanel('editShape')} />
    }

    if (!cameraSelected) return <DefaultButtons highlightAddNetworkCloset={this.state.highlightAddNetworkCloset} />

    return <CameraButtons { ...omit('classes')(this.props) } />
  }
}

export default connect(mapStateToProps, { updateCurrentEntityAction })(injectSheet(style)(BottomBar))



// WEBPACK FOOTER //
// ./src/components/BottomBar/index.js